import { useTranslation } from "react-i18next"
import { ErrorRefreshFallback } from "../../components/ErrorRefreshFallback"
import ErrorBoundary from "../ErrorBoundary"
import { Devices } from "./Devices"
import { EmailPassword } from "./EmailPassword"

export const LoginSecurity = () => {
  const { t } = useTranslation()
  return (
    <div className="py-6">
      <h1 className="font-bold mb-4">{t("loginSecurity.emailPassword")}</h1>
      <ErrorBoundary fallback={<ErrorRefreshFallback />}>
        <EmailPassword />
      </ErrorBoundary>
      <ErrorBoundary
        fallback={<ErrorRefreshFallback />}
        header={
          <h1 className="font-bold pt-6 mb-4">
            {t("loginSecurity.whereYouAreSignedIn")}
          </h1>
        }
      >
        <Devices />
      </ErrorBoundary>
    </div>
  )
}
